<template>
    <div class="text-center clover-frame">
      <p>Please wait while we are processing...</p>
    </div>
  </template>
  <script>
  
  import { mapMutations } from "vuex";
  
  export default {
    name: 'CloverResponse',
    data() {
      return {
     
      };
    },
  
    async mounted() {
      this.vm_mutateCloverDetails({
        clover_response: this.$router.currentRoute.query, //this.$route.query
      })
    },
  
    methods: {
  
      ...mapMutations({
        vm_mutateCloverDetails: "clover/detailsMutate",
      }),
  
    },
  };
  </script>
  
  <style scoped>
  .clover-frame{
      min-height: 500px;
      display: flex;
      justify-content: center;
      align-items: center;
  }
  </style>